var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.054,
    height: 52.772,
    viewBox: "0 0 50.054 52.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffec8b;stroke:#707070;}.b{fill:#3db9e0;}.c{fill:none;}.d{fill:#fff;}.e{clip-path:url(#a);}.f{fill:#e3e3e3;}.g{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,6.291,17.284,0s3.994,23.23.341,37.68C17.344,38.8,16,43.836,15.53,44.832-2.752,50.359,2.479,35.3,2.479,35.3Z",
    transform: "translate(15.75 0) rotate(20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.5,842.761c.815,4.072,1.63,9.541,1.63,9.541s-3.142,2.793-17.92,2.793h-2c-14.777,0-17.92-2.793-17.92-2.793s.814-5.469,1.629-9.541,11.868-7.331,11.868-7.331v-.414c-.041-.209.085-.373.316-.5,0,0,1.275,4.4,5.268,4.4s5.406-4.4,5.406-4.4c.232.128.357.292.315.5l-.187.495S355.686,838.689,356.5,842.761Z",
    transform: "translate(-320.294 -834.515)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 46.569,
    height: 46.569,
    transform: "translate(3.486 6.203)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.417 7.262)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M356.5,842.761c.815,4.072,1.63,9.541,1.63,9.541s-3.142,2.793-17.92,2.793h-2c-14.777,0-17.92-2.793-17.92-2.793s.814-5.469,1.629-9.541,11.868-7.331,11.868-7.331v-.414c-.041-.209.085-.373.316-.5,0,0,1.275,4.4,5.268,4.4s5.406-4.4,5.406-4.4c.232.128.357.292.315.5l-.187.495S355.686,838.689,356.5,842.761Z",
    transform: "translate(-320.294 -815.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M377.57,792.437s1.115.327.848,1.2-1.546,3.263-1.9,3.263h-.35l-.835,1.741s-1.841,2.72-4.168,3.154h-.185c-2.327-.434-4.168-3.154-4.168-3.154l-.836-1.741h-.349c-.349,0-1.629-2.393-1.895-3.263s.848-1.2.848-1.2a1.871,1.871,0,0,1-.11-.217,3.971,3.971,0,0,0,.444-.647,6.012,6.012,0,0,0,.3-.637c.084-.195.178-.386.279-.573a9.637,9.637,0,0,1,1.552-2.058,12.718,12.718,0,0,1,.954-.889q.249-.211.509-.41l.26-.193.074-.053.276.163q.236.134.476.259.48.251.974.467a16.731,16.731,0,0,0,2.028.735,15.422,15.422,0,0,0,2.112.456c.357.051.717.087,1.077.111.181.01.361.02.541.023l.326,0,1.289,2.482A4.019,4.019,0,0,1,377.57,792.437Z",
    transform: "translate(-352.159 -780.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M378.5,767.119a22.4,22.4,0,0,1-.207,4.7l-1.1-2.118-.474,0-.257,0c-.172,0-.343-.012-.514-.023q-.514-.034-1.025-.107a14.47,14.47,0,0,1-2.015-.436,15.687,15.687,0,0,1-1.943-.7q-.474-.207-.932-.445c-.152-.079-.3-.161-.452-.247l-.221-.13-.184-.115-.223-.148-.277.182-.2.14-.277.205q-.274.208-.536.43-.524.444-1.005.938a10.326,10.326,0,0,0-1.662,2.21q-.168.307-.308.631a5.368,5.368,0,0,1-.267.576c-.034.062-.073.121-.11.181a18.859,18.859,0,0,1-.427-5.724c.233-5.113,6.167-5.657,6.167-5.657h2.279S378.263,762.006,378.5,767.119Z",
    transform: "translate(-352.271 -761.462)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M377.57,792.437s1.115.327.848,1.2-1.546,3.263-1.9,3.263h-.35l-.835,1.741s-1.841,2.72-4.168,3.154h-.185c-2.327-.434-4.168-3.154-4.168-3.154l-.836-1.741h-.349c-.349,0-1.629-2.393-1.895-3.263s.848-1.2.848-1.2a1.871,1.871,0,0,1-.11-.217,3.971,3.971,0,0,0,.444-.647,6.012,6.012,0,0,0,.3-.637c.084-.195.178-.386.279-.573a9.637,9.637,0,0,1,1.552-2.058,12.718,12.718,0,0,1,.954-.889q.249-.211.509-.41l.26-.193.074-.053.276.163q.236.134.476.259.48.251.974.467a16.731,16.731,0,0,0,2.028.735,15.422,15.422,0,0,0,2.112.456c.357.051.717.087,1.077.111.181.01.361.02.541.023l.326,0,1.289,2.482A4.019,4.019,0,0,1,377.57,792.437Z",
    transform: "translate(-345.745 -772.771)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(6.413 26.679)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,0H22.852s5.712,35.989,0,47.985S0,47.985,0,47.985Z",
    transform: "translate(2.962 -19.418) rotate(20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.629bd27348d5bd26884857a56f45314c.svg";
export { ForwardRef as ReactComponent };